'use strict';

var es2015 = require('./es2015.js');
var assign$1 = require('./helpers/assign.js');

var ES2015 = es2015;
var assign = assign$1;

var ES2016 = assign(assign({}, ES2015), {
	// https://github.com/tc39/ecma262/pull/60
	SameValueNonNumber: function SameValueNonNumber(x, y) {
		if (typeof x === 'number' || typeof x !== typeof y) {
			throw new TypeError('SameValueNonNumber requires two non-number values of the same type.');
		}
		return this.SameValue(x, y);
	}
});

var es2016 = ES2016;

module.exports = es2016;
